import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export function StatCard({ label, value, tone = "white", testId, sub }) {
  const tones = { white: "bg-white", yellow: "bg-[#FACC15]", black: "bg-black text-white", red: "bg-[#FEF2F2]" };
  return (
    <div className={`rounded-xl border-2 border-black p-4 ${tones[tone]}`} data-testid={testId}>
      <p className={`text-[10px] font-bold uppercase tracking-[0.2em] ${tone === "black" ? "text-zinc-300" : "text-zinc-600"}`}>{label}</p>
      <p className="mt-1 font-display text-3xl font-extrabold tabular-nums">{value ?? "—"}</p>
      {sub && <p className={`text-xs ${tone === "black" ? "text-zinc-300" : "text-zinc-500"}`}>{sub}</p>}
    </div>
  );
}

export function StatCards({ stats: base, range, setRange }) {
  const { data: ranged } = useQuery({
    queryKey: ["stats", range],
    queryFn: () => api.get("/tickets/stats", { params: { range } }).then((r) => r.data),
    refetchInterval: 30000,
  });
  const stats = ranged || base;
  const label = range === "7d" ? "last 7 days" : "today";
  return (
    <div className="space-y-3">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="text-sm font-bold text-zinc-600">Your numbers · <span className="text-black">{label}</span></p>
        <div className="inline-flex rounded-xl border-2 border-black bg-white p-0.5" data-testid="stats-range-toggle">
          {[["today", "Today"], ["7d", "Last 7 days"]].map(([v, l]) => (
            <button key={v} type="button" onClick={() => setRange(v)} className={`rounded-lg px-3 py-1 text-xs font-bold ${range === v ? "bg-black text-white" : "hover:bg-[#FEF9C3]"}`} data-testid={`stats-range-${v}`}>
              {l}
            </button>
          ))}
        </div>
      </div>
      <div className="grid grid-cols-2 gap-3 md:grid-cols-3 lg:grid-cols-5">
        <StatCard label="My unresolved" value={stats?.my_unresolved} tone="yellow" testId="stat-my-unresolved" sub={range === "7d" ? "created in last 7 days" : "assigned to me, not resolved"} />
        <StatCard label="Unassigned today" value={stats?.unassigned_today} tone="red" testId="stat-unassigned-today" sub="today only · live" />
        <StatCard label="I resolved" value={stats?.resolved_by_me} tone="black" testId="stat-resolved-by-me" sub={label} />
        <StatCard label="Total leads" value={stats?.total} testId="stat-total" sub={`${stats?.total_today ?? 0} today`} />
        <StatCard label="Open · In-progress" value={stats ? `${stats.open} · ${stats.in_progress}` : null} testId="stat-open" sub={`${stats?.waiting ?? 0} waiting on student · ${stats?.resolved ?? 0} resolved`} />
      </div>
    </div>
  );
}
